(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gallery--product"] && !Shopify.designMode) return;
  try {
    let logs = false;
  let flkty = null;
  let counterObserver = null;
  let galleryMode = null;
  let flickityPending = false;
  let galleryResizeObserver = null;
  let galleryResizeFrame = 0;

  const mq = window.matchMedia("(min-width: 1084px)");

  function destroyGallery() {
    if (galleryResizeObserver) {
      galleryResizeObserver.disconnect();
      galleryResizeObserver = null;
    }
    if (galleryResizeFrame) {
      cancelAnimationFrame(galleryResizeFrame);
      galleryResizeFrame = 0;
    }
    if (flkty) {
      flkty.destroy();
      flkty = null;
    }
    if (counterObserver) {
      counterObserver.disconnect();
      counterObserver = null;
    }
  }

  function whenLcpImageReady(carousel, callback) {
    const lcpImg = carousel.querySelector(
      '.gallery-media__item img[fetchpriority="high"], .gallery-media__item img[loading="eager"]'
    );
    if (!lcpImg || lcpImg.complete) {
      callback();
      return;
    }
    const done = () => {
      lcpImg.removeEventListener("load", done);
      lcpImg.removeEventListener("error", done);
      callback();
    };
    lcpImg.addEventListener("load", done);
    lcpImg.addEventListener("error", done);
  }

  function scheduleAfterPaint(fn) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(() => fn(), { timeout: 500 });
    } else {
      setTimeout(fn, 0);
    }
  }

  function productCarousel(carousel, nav, galleryWrapper, counter) {
    if (!carousel || flkty) return;

    flkty = new Flickity(carousel, {
      wrapAround: true,
      cellAlign: "left",
      percentPosition: false,
      prevNextButtons: false,
      cellSelector: ".gallery-media__item",
      pageDots: false,
      draggable: false
    });

    if (counter) {
      flkty.on("change", (index) => {
        const counterIndex = galleryWrapper.querySelector(".gallery-counter__index");
        if (counterIndex) counterIndex.textContent = index + 1;
      });
    }

    flkty.on("staticClick", (event, pointer, cellElement) => {
      if (!cellElement) return;

      const clickedCell = cellElement.querySelector(".gallery-media");
      const isVideo = clickedCell && clickedCell.querySelector("video");

      if (event.target.closest(".gallery-media__icon")) {
        const video = clickedCell.querySelector("video");
        const button = clickedCell.querySelector(".gallery-media__icon");

        if (video.paused) {
          video.play().then(() => {
            video.parentNode.classList.add("is-playing");
            button.setAttribute("aria-hidden", true);
            video.setAttribute("controls", "controls");
          }).catch((err) => {
            console.warn("Video play() failed:", err);
          });
        } else {
          video.pause();
          video.parentNode.classList.remove("is-playing");
          button.setAttribute("aria-hidden", false);
          video.removeAttribute("controls");
        }

        video.addEventListener("ended", function () {
          video.pause();
          video.currentTime = 0;
          video.parentNode.classList.remove("is-playing");
          button.setAttribute("aria-hidden", false);
          button.setAttribute("aria-label", "Play video");
          video.removeAttribute("controls");
        });
        return;
      }

      if (isVideo) {
        const video = clickedCell.querySelector("video");
        const button = clickedCell.querySelector(".gallery-media__icon");
        if (video && !video.paused) {
          video.pause();
          video.parentNode.classList.remove("is-playing");
          if (button) button.setAttribute("aria-hidden", false);
          video.removeAttribute("controls");
        }
      }

      flkty.next();
    });

    if (nav) {
      const firstItem = carousel.querySelector(".gallery-media__item");
      const slideHeight = firstItem ? firstItem.offsetHeight : 0;
      let previousIndex = 0;
      const navItems = nav.querySelectorAll(".gallery-nav__item");

      if (slideHeight) nav.style.height = slideHeight + "px";

      function updateNav(index, shouldScroll) {
        const item = navItems[index];
        if (!item) return;

        navItems.forEach((navItem, itemIndex) => {
          navItem.classList.toggle("selected", itemIndex === index);
        });

        if (shouldScroll) {
          let scrollPosition;
          if (index >= previousIndex) {
            scrollPosition = Math.max(0, item.offsetTop - nav.clientHeight * 0.33);
          } else {
            scrollPosition = Math.max(0, item.offsetTop - nav.clientHeight * 0.66);
          }
          nav.scrollTo({ top: scrollPosition, behavior: "smooth" });
        }
        previousIndex = index;
      }

      navItems.forEach((item, index) => {
        item.addEventListener("click", () => {
          flkty.select(index);
          updateNav(index, true);
        });
      });

      flkty.on("select", () => {
        updateNav(flkty.selectedIndex, true);
      });
    }

    // Flickity only re-measures on window resize; the gallery column can change width later
    // (late app widgets / fonts in the 1fr info column), which leaves slides offset.
    if (typeof ResizeObserver === "function") {
      let lastWidth = flkty.size ? flkty.size.innerWidth : 0;

      const remeasure = () => {
        if (!flkty) return;
        if (flkty.isAnimating) {
          flkty.once("settle", remeasure);
          return;
        }
        flkty.resize();
        if (nav && flkty.maxCellHeight) nav.style.height = flkty.maxCellHeight + "px";
      };

      galleryResizeObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0].contentRect.width);
        if (!width || width === Math.round(lastWidth)) return;
        lastWidth = width;
        if (galleryResizeFrame) cancelAnimationFrame(galleryResizeFrame);
        galleryResizeFrame = requestAnimationFrame(() => {
          galleryResizeFrame = 0;
          remeasure();
        });
      });
      galleryResizeObserver.observe(carousel);
    }
  }

  function scrollCounter(galleryWrapper) {
    if (!galleryWrapper || counterObserver) return;

    const counter = galleryWrapper.querySelector(".gallery-counter");
    if (!counter) return;

    const mediaItems = galleryWrapper.querySelectorAll(".gallery-media__item");

    counterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            const currentIndex = parseInt(entry.target.dataset.index, 10);
            if (!isNaN(currentIndex)) {
              counter.querySelector(".gallery-counter__index").textContent = currentIndex;
            }
          }
        });
      },
      { threshold: [0, 0.5, 1], rootMargin: "0px" }
    );

    mediaItems.forEach((item) => counterObserver.observe(item));
  }

  function initGallery() {
    const nextMode = mq.matches ? "desktop" : "mobile";

    // Already fully initialized for this breakpoint
    if (nextMode === galleryMode) {
      if (nextMode === "desktop" && flkty) return;
      if (nextMode === "mobile" && counterObserver) return;
    }

    if (nextMode === "desktop" && typeof Flickity === "undefined") {
      setTimeout(initGallery, 100);
      return;
    }

    if (galleryMode !== nextMode) {
      destroyGallery();
      galleryMode = nextMode;
      flickityPending = false;
    }

    const carousel = document.querySelector(".product-main__gallery--carousel");
    const nav = document.querySelector(".product-main__gallery-nav");
    const galleryWrapper = document.querySelector(".product-main__gallery-container");
    const desktopCounter = galleryWrapper
      ? galleryWrapper.dataset.desktopCounter === "true"
      : false;

    if (nextMode === "desktop") {
      if (!carousel || flkty || flickityPending) return;
      flickityPending = true;
      whenLcpImageReady(carousel, () => {
        scheduleAfterPaint(() => {
          flickityPending = false;
          if (!mq.matches || galleryMode !== "desktop" || flkty) return;
          productCarousel(carousel, nav, galleryWrapper, desktopCounter);
        });
      });
    } else {
      scrollCounter(galleryWrapper);
    }
  }

  initGallery();

  mq.addEventListener("change", () => {
    galleryMode = null;
    initGallery();
  });

  document.addEventListener("variantImageChange", (event) => {
    if (mq.matches) {
      if (flkty && event.detail.index !== undefined) {
        flkty.select(event.detail.index, false, true);
      }
      return;
    }
    if (event.detail.variantId) {
      const galleryContainer = document.querySelector(".product-main__gallery");
      const matchingImage =
        galleryContainer &&
        galleryContainer.querySelector(`[data-variant="${event.detail.variantId}"]`);
      if (matchingImage && matchingImage.parentNode) {
        galleryContainer.scrollTo({
          left: matchingImage.parentNode.offsetLeft,
          behavior: "smooth"
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
